<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>신청서 리스트</strong>
          </div>
          <b-row>
            <b-col
              md="5"
              class="text-left"
            >
              <b-input-group
                name="partSet"
                prepend="연도"
                label-for="part"
                class="mb-2"
              >
                <b-form-select
                  v-model="term"
                  :disabled="part==='권한없음'"
                  :options="termOptions"
                  @change="getApplyListTerm"
                />
              </b-input-group>
            </b-col>
            <b-col
              md="5"
              class="text-left"
            >
              <b-input-group
                name="partSet"
                prepend="부서"
                label-for="part"
                class="mb-2"
              >
                <b-form-select
                  v-model="part"
                  :disabled="part==='권한없음'"
                  :options="partOptions"
                  @change="getApplyList"
                />
                <b-input-group-append>
                  <b-btn
                    :disabled="part==='권한없음'"
                    variant="primary"
                    size="sm"
                    @click="getApplyList(part)"
                  >
                    새로고침
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col
              md="4"
            >
              <b-form-group
                label="Per page"
                label-cols-sm="6"
                label-cols-md="4"
                label-cols-lg="3"
                label-align-sm="right"
                label-size="sm"
                label-for="perPageSelect"
                class="mb-0"
              >
                <b-form-select
                  id="perPageSelect"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                />
              </b-form-group>
            </b-col>
            <b-col md="5">
              <b-input-group size="sm">
                <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Type to Search"
                />
                <b-input-group-append>
                  <b-button
                    :disabled="!filter"
                    @click="filter = ''"
                  >
                    Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="3">
              <h4>
                <b-badge
                  variant="dark"
                >
                  <strong>Total: {{ totalRows }}</strong>
                </b-badge>
              </h4>
            </b-col>
          </b-row>
          <b-row
            align-h="center"
            class="text-left"
          >
            <b-table
              class="mb-0 table-outline"
              head-variant="light"
              hover
              :sort-by.sync="sortBy"
              :items="itemAll"
              :fields="fieldsAll"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
            >
              <template
                v-slot:cell(part)="data"
              >
                <div>
                  {{ data.value }}
                </div>
              </template>
              <template
                v-slot:cell(name)="data"
              >
                <b-button
                  variant="outline-success"
                  size="md"
                  @click="showRowDetail(data.item.email, data.item._showDetails)"
                >
                  <b> {{ data.value }}</b>
                </b-button>
              </template>
              <template
                v-slot:cell(rank)="data"
              >
                <div>
                  {{ data.value }}
                </div>
              </template>
              <template
                v-slot:cell(appliedTitle)="data"
              >
                <div>
                  {{ data.item.schlsType }}
                  <h4>
                    <b-badge
                      v-for="(cert, idx) in data.item.certs"
                      :key="idx"
                      :href="serverUri + '/cdn/pdf?id=' + cert.id + '&email=' + data.item.email"
                    >
                      <font-awesome-icon :icon="['fas', 'file-pdf']" />
                    </b-badge>
                  </h4>
                </div>
              </template>
              <template
                v-slot:cell(title)="data"
              >
                <div>
                  {{ data.value }}
                </div>
              </template>
              <template
                v-slot:cell(its)="data"
              >
                <div>
                  <h5>
                    <b-badge
                      v-if="data.value"
                      variant="info"
                    >
                      {{ data.value }}
                    </b-badge>
                  </h5>
                </div>
              </template>
              <template
                v-slot:cell(modifiedDate)="data"
              >
                {{ data.value }}
              </template>
              <template
                v-slot:row-details="row"
              >
                <b-button
                  size="sm"
                  @click="generateInfo(row.item)"
                >
                  Print Info
                </b-button>
                <b-card>
                  <remnant-past-review
                    v-if="$store.getters.authName !== '인턴십부'"
                    ref="remnantPastReview"
                    :email="row.item.email"
                    :no-review="false"
                  />
                  <remnant-past-omc
                    v-if="$store.getters.authName !== '인턴십부'"
                    ref="remnantPastOmc"
                    :email="row.item.email"
                  />
                  <apply-review
                    v-if="$store.getters.authName !== '인턴십부'"
                    ref="applyReview"
                    :apply-id="row.item.applyId"
                    :email="row.item.email"
                    :part="row.item.part"
                    :read-only="freezing('review')"
                    :longterm="row.item.longterm"
                    @reviewUpdated="getApplyList(part)"
                  />
                  <hr>
                  <b-row class="mb-2">
                    <b-col md="12">
                      <b-form-input
                        v-model="row.item.email"
                        :readonly="true"
                      />
                    </b-col>
                  </b-row>
                  <remnant-basic
                    ref="remnantBasic"
                    :email="row.item.email"
                    :read-only="true"
                  />
                  <remnant-family
                    ref="remnantFamily"
                    :email="row.item.email"
                    :read-only="true"
                    :check-sibling-term="term"
                  />
                  <remnant-training
                    ref="remnantTraining"
                    :email="row.item.email"
                    :read-only="true"
                  />
                  <hr>
                  <longterm-report
                    v-if="row.item.longterm > 0"
                    :email="row.item.email"
                    :apply-id="row.item.applyId"
                    :longterm="row.item.longterm"
                    :initial-read-only="true"
                    :no-edit="freezing('longterm')"
                  />
                  <apply-info
                    v-else
                    :email="row.item.email"
                    :apply-id="row.item.applyId"
                    :initial-read-only="true"
                    :no-edit="freezing('apply')"
                  />
                </b-card>
              </template>
            </b-table>
          </b-row>
          <b-row
            align-h="center"
            class="my-1"
          >
            <b-col
              cols="5"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '../api'
import RemnantBasic from './remnant/RemnantBasic'
import RemnantFamily from './remnant/RemnantFamily'
import RemnantTraining from './remnant/RemnantTraining'
import RemnantPastReview from './remnant/RemnantPastReview'
import RemnantPastOmc from './remnant/RemnantPastOmc'
import ApplyReview from './admin/ApplyReview'
import ApplyInfo from './apply/ApplyInfo'
import LongtermReport from './apply/LongtermReport'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'
library.add(faFilePdf)
export default {
  name: 'ApplyList',
  components: { RemnantBasic, RemnantFamily, RemnantTraining, RemnantPastReview, RemnantPastOmc, ApplyInfo, ApplyReview, LongtermReport },
  data: function () {
    return {
      filter: null,
      filterOn: ['name', 'appliedTitle', 'its'],
      totalRows: 0,
      currentPage: 1,
      perPage: 100,
      pageOptions: [10, 15, 20, 50, 100],
      part: '권한없음',
      partOptions: [],
      term: '',
      termOptions: [],
      itemAll: [],
      serverUri: api.serverURI,
      lock: {
        review: true,
        apply: true,
        longterm: true
      },
      sortBy: 'part',
      fieldsAll: [
        {
          key: 'part',
          label: '부서',
          sortable: true
        },
        {
          key: 'name',
          label: '이름',
          sortable: true
        },
        {
          key: 'rank',
          label: '순위',
          sortable: true,
          formatter: (value, key, item) => {
            if (item.longterm === 0) {
              if (value > -1) {
                return value
              } else {
                return ''
              }
            }
            switch (item.longterm) {
              case 1:
                return '장기 - 장학부 추천'
              case 2:
                return '장기 - 부서 추천'
              case 3:
                return '장기 - 지정 기탁'
              default:
                return '장기'
            }
          }
        },
        {
          key: 'appliedTitle',
          label: '신청',
          sortable: true
        },
        {
          key: 'title',
          label: '최종선정',
          sortable: true,
          formatter: (value, key, item) => {
            return this.$store.getters.isSuper ? value : 'TBD'
          },
          sortByFormatted: true,
          filterByFormatted: true
        },
        {
          key: 'its',
          label: '인턴십',
          sortable: true,
          formatter: (value, key, item) => {
            return value ? '신청' : ''
          },
          sortByFormatted: true,
          filterByFormatted: true
        },
        {
          key: 'modifiedDate',
          label: '등록일',
          sortable: true,
          formatter: (value, key, item) => {
            return api.unixTimeToDate(value)
          },
          sortByFormatted: false,
          filterByFormatted: true
        }
      ]
    }
  },
  async mounted () {
    // IECHECK
    if (window.document.documentMode) {
      alert('인터넷 익스플로러는 지원되지 않습니다. 크롬, 웨일, 사파리, 엣지 등을 사용해주세요 (Internet Explorer is not supported)')
      this.$router.push('/dashboard')
      return
    }
    if (this.$store.getters.isRemnant) {
      this.$router.push('/dashboard')
    }
    await this.getPartTable()
    await this.getTermList()
    this.getApplyList(this.part)
  },
  methods: {
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    generateInfo (item) {
      let url = '/apply/print'
      this.$store.commit('setPrintId', item.applyId)
      this.$store.commit('setPrintLongterm', item.longterm)
      window.open(url, '_blank')
    },
    freezing (docType) {
      if (this.$store.getters.isRealSuper) {
        return false
      }
      return this.lock[docType] || this.$store.getters.isReader
    },
    getLocks (term) {
      this.isLock('review', term)
    },
    isLock (docType, term) {
      api.request('get', '/admin/control/lock?doc=' + docType + '&term=' + term)
        .then(response => {
          let data = response.data
          if (!data.lock) {
            this.lock[docType] = false
          } else {
            this.lock[docType] = true
          }
        })
        .catch(error => {
          console.log(error)
          this.lock[docType] = true
        })
    },
    showRowDetail (email, val) {
      this.itemAll.forEach(row => {
        if (row.email === email) {
          row._showDetails = !val
        } else {
          row._showDetails = false
        }
      })
    },
    parseApply (data) {
      this.itemAll = []
      data.forEach(elem => {
        var item = {}
        item['part'] = elem.part
        item['schlsType'] = elem.schlsType
        item['applyId'] = elem.applyId
        item['name'] = elem.name
        item['rank'] = elem.rank < 0 ? '-1' : elem.rank
        item['title'] = elem.title === '' ? '미선정' : elem.title
        item['certs'] = elem.certs
        item['its'] = elem.its > 0
        item['email'] = elem.email
        item['longterm'] = elem.longterm
        item['modifiedDate'] = elem.modifiedDate
        item['_showDetails'] = false
        this.itemAll.push(item)
      })
      this.totalRows = this.itemAll.length
    },
    getPartTable () {
      return api.request('get', '/auth/part?' + 'auth=' + this.$store.getters.authName)
        .then(response => {
          var data = response.data
          if (data.error) {
            this.alertFail(data.error)
            return
          }
          this.partOptions = data.partTable
          if (this.partOptions.length > 0) {
            this.part = this.partOptions[0]
          } else {
            // 권한 없음
            this.part = '권한없음'
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getApplyList (part) {
      if (part === '권한없음') {
        return
      }
      this.getLocks(this.term)
      /* file 처리 성공하고 돌아온 file명들을 문서에 넣는다. */
      api.request('get', '/apply/list?part=' + part + '&term=' + this.term + '&auth=' + this.$store.state.AUTH)
        .then(response => {
          var data = response.data
          this.parseApply(data.docs)
        })
        .catch(error => {
          alert(error.response.data.error)
        })
    },
    getApplyListTerm (term) {
      this.getLocks(term)
      /* file 처리 성공하고 돌아온 file명들을 문서에 넣는다. */
      api.request('get', '/apply/list?part=' + this.part + '&term=' + term + '&auth=' + this.$store.state.AUTH)
        .then(response => {
          var data = response.data
          this.parseApply(data.docs)
        })
        .catch(error => {
          alert(error.response.data.error)
        })
    },
    getTermList () {
      /* file 처리 성공하고 돌아온 file명들을 문서에 넣는다. */
      return api.request('get', '/auth/termlist?auth=' + this.$store.state.AUTH)
        .then(response => {
          var data = response.data
          /* result term */
          this.termOptions = []
          data.terms.forEach(term => {
            this.termOptions.push(term)
          })
          if (this.termOptions.length > 0) {
            this.term = this.termOptions[0]
          }
        })
        .catch(error => {
          alert(error.response.data.error)
        })
    }
  }
}
</script>

<style scoped>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
